import React from 'react';
import { Container } from './ChartContainer.styles';

export const ChartContainer = ({ chartRef }) => (
  <Container>
    <canvas ref={chartRef} />
  </Container>
);
